module.exports = __webpack_public_path__ + "static/media/33.7444c13b.png";